import Vue from 'vue';

import { capitalize } from '@/helpers/StringHelpers';

// S'occupe de capitaliser toutes les premières lettres, un peu comme le ferait text-transform: capitalize en css.
// Une lettre est capitalisée après un espace (" ") ou un tiret ("-")
const Capitalize = Vue.directive('capitalize', {
  update(el) {
    const sourceValue = el.value;
    const newValue = capitalize(sourceValue);

    if (sourceValue !== newValue) {
      const position = el.selectionStart;
      el.value = newValue;
      el.selectionEnd = position;
      el.dispatchEvent(new Event('input'), { bubbles: true });
    }
  },
});

export default Capitalize;
